const en = {
  nav: {
    home:          'Home',
    myOrder:       'My Order',
    history:       'History',
    admin:         'Administration',
    signOut:       'Sign out',
    administrator: 'Administrator',
    user:          'User',
    manages:       'Manages',
    personal:      'Personal',
  },
  common: {
    restaurant:    'Restaurant',
    menu:          'Menu',
    price:         'Price',
    status:        'Status',
    date:          'Date',
    user:          'User',
    email:         'Email',
    name:          'Name',
    description:   'Description',
    imageUrl:      'Image URL',
    country:       'Country',
    argentina:     'Argentina',
    chile:         'Chile',
    colombia:      'Colombia',
    allCountries:  'All countries',
    cancel:        'Cancel',
    save:          'Save',
    create:        'Create',
    edit:          'Edit',
    delete:        'Delete',
    add:           'Add',
    update:        'Update',
    confirm:       'Confirm',
    close:         'Close',
    back:          'Back',
    exportExcel:   'Export to Excel',
    active:        'Active',
    cancelled:     'Cancelled',
    inactive:      'Inactive',
    celiac:        'Gluten-free option',
    yes:           'Yes',
    no:            'No',
    notes:         'Notes',
    category:      'Category',
    whatsapp:      'WhatsApp',
    orderDate:     'Order Date',
    dish:          'Dish',
    total:         'Total',
    role:          'Role',
    month:         'Month',
    year:          'Year',
  },
  dashboard: {
    welcome:                  'Welcome, {{name}}!',
    subtitle:                 'Select your lunch for today',
    ordersOpen:               'Orders Open',
    ordersClosed:             'Orders Closed',
    ordersOpenDesc:           'You can place or modify your order from 8:00 AM to 6:00 PM',
    ordersClosedHours:        'Orders are available from 8:00 AM to 6:00 PM',
    ordersClosedDay:          'Today\'s orders are closed. Come back tomorrow!',
    myOrdersToday:            'Your Orders Today',
    myOrderToday:             'Your Order Today',
    selectRestaurant:         'Select a Restaurant',
    selectRestaurantPh:       '-- Select a restaurant --',
    selectMenu:               'Select a Menu',
    noMenus:                  'No menus available for this restaurant',
    addOrder:                 'Add Order',
    confirmOrder:             'Confirm Order',
    updateOrder:              'Update Order',
    modifyOrder:              'Modify Order',
    cancelOrder:              'Cancel Order',
    closedTitle:              'Orders Closed',
    closedDesc:               'Today\'s orders are closed. Come back tomorrow to place your order.',
    cancelConfirm:            'Are you sure you want to cancel this order?',
    errorSelect:              'Please select a restaurant and a menu item',
    successAdd:               'Order added successfully!',
    successUpdate:            'Order updated successfully!',
    successCreate:            'Order placed successfully!',
    successCancel:            'Order cancelled successfully',
    errorLoad:                'Error loading data',
    errorOrder:               'Error processing order',
    errorCancel:              'Error cancelling order',
    errorMenuItems:           'Error loading menu items',
  },
  history: {
    title:         'Order History',
    subtitle:      'Review your previous orders',
    empty:         'No orders in history',
    emptyDesc:     'Your previous orders will appear here',
    today:         'Today',
    order_one:     '{{count}} order',
    order_other:   '{{count}} orders',
    totalDay:      'Day total:',
    errorLoad:     'Error loading history',
  },
  admin: {
    title:              'Administration Panel',
    subtitle:           'Manage restaurants, menus and orders',
    tabToday:           'Today\'s Lunch',
    tabRestaurants:     'Restaurants',
    tabUsers:           'Users',
    tabReports:         'Reports',
    // Today
    noLunch:            'No lunch scheduled for today',
    noLunchDesc:        'Lunches are managed automatically when users place their orders.',
    noLunchNote:        'The day\'s lunch is created automatically when the first user places an order.',
    totalOrders:        'Total Orders',
    diners:             'Diners',
    totalAmount:        'Total Amount',
    restaurants:        'Restaurants',
    manualEntry:        'Manual Entry',
    manualEntryDetails: 'Manual Entry Details',
    registeredBy:       'Registered by',
    closeLunch:         'Close Lunch',
    reopenLunch:        'Reopen Lunch',
    closeManual:        'Close with Manual Entry',
    closeLunchConfirm:  'Are you sure you want to close today\'s lunch?',
    reopenLunchConfirm: 'Are you sure you want to reopen today\'s lunch?',
    whatsappOrder:      'Order via WhatsApp',
    cancelOrder:        'Cancel Order',
    cancelOrderConfirm: 'Are you sure you want to cancel {{name}}\'s order?',
    // Restaurants
    addRestaurant:      'Add Restaurant',
    editRestaurant:     'Edit Restaurant',
    restaurantName:     'Restaurant name',
    isDefault:          'Default restaurant',
    viewMenu:           'View Menu',
    noRestaurants:      'No restaurants registered',
    deleteRestaurantConfirm: 'Are you sure you want to delete this restaurant?',
    // Menu items
    menuOf:             '{{name}} Menu',
    addDish:            'Add Dish',
    editDish:           'Edit Dish',
    dishName:           'Dish name',
    isCeliac:           'Gluten-free option',
    noMenuItems:        'No dishes registered',
    deleteDishConfirm:  'Are you sure you want to delete this dish?',
    // Users
    addUser:            'Add User',
    noUsers:            'No users registered',
    changeRole:         'Change Role',
    resetPassword:      'Reset Password',
    disable:            'Disable',
    enable:             'Enable',
    deleteUser:         'Delete',
    disableConfirm:     'Are you sure you want to disable {{email}}?',
    enableConfirm:      'Are you sure you want to enable {{email}}?',
    resetConfirm:       'Are you sure you want to reset the password for {{email}}?',
    deleteUserConfirm:  'Are you sure you want to permanently delete {{email}}? This action cannot be undone.',
    tempPassword:       'Temporary password',
    copyPassword:       'Copy',
    copied:             'Copied!',
    // Reports
    reportByUser:       'Orders by User',
    topUsers:           'TOP 10 Users',
    topRestaurants:     'TOP 10 Restaurants',
    topDishes:          'TOP 10 Dishes',
    selectUser:         'Select a user',
    generate:           'Generate',
    dateRange:          'Date range',
    byMonth:            'By month',
    customRange:        'Custom range',
    startDate:          'Start date',
    endDate:            'End date',
    ordersCount:        'Orders',
    noResults:          'No results',
    // Manual close
    manualRestaurantName: 'Restaurant name',
    manualDiners:         'Number of diners',
    manualAmount:         'Total amount',
    manualNotes:          'Notes (optional)',
    confirmManualClose:   'Close with Manual Entry',
  },
  language: {
    es: 'Español',
    en: 'English',
  },
} as const;

export default en;
